import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Clock, Lightbulb, Target, ClipboardCheck, Users, FileText } from 'lucide-react';
const items = [{
  icon: Target,
  title: 'El sistema completo Mapa 3C + Bloque 7',
  desc: 'La metodología base para estructurar cualquier clase.'
}, {
  icon: Clock,
  title: 'Protocolo de planeación en 15 minutos',
  desc: 'Guía paso a paso para no perder tiempo divagando.'
}, {
  icon: Lightbulb,
  title: '12 ganchos universales',
  desc: 'Formas de iniciar la clase que prenden la atención sin infantilizar.'
}, {
  icon: BookOpen,
  title: 'Micro-modelos (M4)',
  desc: 'Técnicas para explicar conceptos complejos sin dar cátedra eterna.'
}, {
  icon: ClipboardCheck,
  title: 'Banco de evidencias rápidas + Rúbrica',
  desc: 'Actividades de 3–8 min y rúbrica de 4 puntos para evaluar al vuelo.'
}, {
  icon: Users,
  title: 'Adaptaciones para grupos difíciles',
  desc: 'Estrategias para contextos sin tecnología o grupos numerosos.'
}, {
  icon: FileText,
  title: 'Plantillas editables (Docs/Slides)',
  desc: 'Listas para copiar, pegar y reutilizar inmediatamente.'
}];
export function WhatIncludes() {
  return <section className="w-full max-w-3xl mx-auto px-6 py-16 bg-white rounded-2xl shadow-sm border border-gray-100 my-16" data-id="element-228">
      <div className="text-center mb-12" data-id="element-229">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy" data-id="element-230">
          Qué incluye
        </h2>
        <p className="text-gray-500 mt-2" data-id="element-231">(lo que de verdad vas a usar)</p>
      </div>

      <div className="space-y-6" data-id="element-232">
        {items.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="flex gap-4 p-4 hover:bg-cream/50 rounded-lg transition-colors border-b border-gray-50 last:border-0" data-id="element-233">
            <div className="shrink-0" data-id="element-234">
              <div className="w-10 h-10 rounded-full bg-navy/5 flex items-center justify-center text-navy" data-id="element-235">
                <item.icon className="w-5 h-5" data-id="element-236" />
              </div>
            </div>
            <div data-id="element-237">
              <h3 className="font-bold text-navy text-lg" data-id="element-238">{item.title}</h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-239">{item.desc}</p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}